export default __webpack_public_path__ + "static/media/about.a1b52ca0.png";